import endpoints from 'config/endpoints';

import storeModuleFactory from 'util/storeModule/storeModuleFactory';

import {TIMESTAMP_MULTIPLY, PERCENT, TIMEOUT_STORE} from 'util/constants';

const LIMIT_RESULTS = 10;

module.exports = storeModuleFactory({
    name:          'reportingBackupsHost',
    endpoint:      endpoints.reportingBackupsHost.endpoint,
    timeout:       TIMEOUT_STORE.TIMEOUT_STORE_BIG,
    sortParamsMap: {
        gb:          'backup',
        articleName: 'name'
    },
    filterParamsMap: {
        startDate: 'start_date',
        endDate:   'end_date',
        host:      'host'
    },
    parseParameters: (parameters, selectedHosts) => ({
        start_date: Math.floor(parameters.startDate / TIMESTAMP_MULTIPLY),
        end_date:   Math.floor(parameters.endDate / TIMESTAMP_MULTIPLY),
        host:       parameters.selectedHosts
    }),
    defaultParameters: {
        limit: LIMIT_RESULTS
    },
    transformResultsFn: json => json.hosts.map(host => ({
        id:         host.host.id,
        name:       host.host.name,
        backupSize: host.backup_size,
        percentage: host.backup_size / json.total_backup_size * PERCENT
    }))
});



// WEBPACK FOOTER //
// ./src/modules/store/reportingBackupsHost.js